/* Component Dependencies */
var certificateStatusTemplate = require('templates/certificateStatus.hbs');
var certificateStatusAssociateTemplate = require('templates/certificateStatus-associate.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Popup = require('libs/popup');


PubSub.register(AriesComponent.extend({
		type: 'certificateStatus',
		template: {
		  'certificateStatus': certificateStatusTemplate,
		  'certificateStatus-associate': certificateStatusAssociateTemplate
		},
bindEvents: function() {
		var _self =this;
    if(_self.$el.data('showOverlay')) {
      _self.$el.find('.use-term-link').on('click',_self.openPopUp.bind(_self));
    }
  },
		openPopUp: function (e) {
			  e.preventDefault();
					var autoOrderedPopup = new Popup({
							selector: '.use-term-link',
							sourceBlock: '.modal-content',
							alternateCloseMarkup: true
					});
				 autoOrderedPopup.register();
		}
}));
